import { styled } from '@material-ui/core';
import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import InnerHeader from '../../../component/InnerHeader';
import NoxTable from '../../../component/Table';
import { useDeleteCpanel, useAccounts } from '../../../hooks/cpanel';

import useToggle from '../../../hooks/useToggle';
import ResourceForm from '../../../component/forms/CpanelForm';

const Wrapper = styled('div')({
  height: 'calc(100vh-10.5rem)'
});

const transformData = (resources) => {
  if (!resources || !resources.length) {
    return [];
  }

  return resources.map(({ domainName, username, password, email, createdAt }, idx) => {
    return {
      createdAt: new Date(createdAt).toLocaleString(),
      domainName,
      email,
      key: idx,
      password,
      username
    };
  });
};

const Cpanel = () => {
  const { handleOpen, handleClose, open } = useToggle();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const { mutate: deleteCpanelMutation, isLoading: deletingCpanel } = useDeleteCpanel();
  const currentProject = useSelector(({ project }) => project.currentProject);
  const { data, isLoading: cpanelsLoading, isFetching } = useAccounts(currentProject._id);

  const deleteCpanel = () => {
    selectedRowKeys.forEach((idx) => {
      const item = data.cPanel[idx];
      deleteCpanelMutation({
        cpanelId: item._id,
        projectId: currentProject._id,
        username: item.username
      });
    });

    setSelectedRowKeys([]);
  };

  const columns = useMemo(() => [
    {
      dataIndex: 'domainName',
      key: 'domainName',
      sorter: (a, b) => a.domainName.toString().localeCompare(b.domainName),
      title: 'Doman Name'
    },
    {
      dataIndex: 'username',
      key: 'username',
      sorter: (a, b) => a.username.toString().localeCompare(b.username),
      title: 'Username'
    },
    {
      dataIndex: 'password',
      key: 'password',
      sorter: (a, b) => a.password.toString().localeCompare(b.password),
      title: 'Password'
    },
    {
      dataIndex: 'email',
      key: 'email',
      render: (email) => <div>{email}</div>,
      sorter: (a, b) => a.email - b.email,
      title: 'Email'
    },
    {
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (createdAt) => <div>{createdAt}</div>,
      sorter: (a, b) => a.createdAt - b.createdAt,
      title: 'Created At'
    }
  ]);

  const actions = [
    {
      onClick: () => window.open('https://cp31.mdello.com:2083/', '_blank'),
      title: 'Go to cPanel',
      type: 'primary'
    },
    {
      onClick: handleOpen,
      title: 'Create Account',
      type: 'primary'
    }
  ];

  if (selectedRowKeys.length) {
    actions.unshift({
      onClick: deleteCpanel,
      title: 'Delete',
      type: 'default'
    });
  }

  const transformedData = useMemo(() => transformData(data?.cPanel), [data?.cPanel]);

  return (
    <Wrapper>
      <InnerHeader title="Cpanel" />
      <NoxTable
        actions={actions}
        columns={columns}
        data={transformedData}
        loading={cpanelsLoading || deletingCpanel || isFetching}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
      />
      <ResourceForm currentProject={currentProject._id} handleClose={handleClose} open={open} />
    </Wrapper>
  );
};

export default Cpanel;
